module.exports = __webpack_public_path__ + "static/footer-red-background-d4250b4bb0ed9dc8a72b2f1c645674b0.svg";